import { makeStyles } from "@fluentui/react-components";
import SocialMedia from "./SocialMedia";
import Legal from "./Legal";
import ContactDetails from "./ContactDetails";
import Logo from "./Logo";
import Address from "./Address";
import { dolphinTokens } from "../../utils/Theme";

const useStyles = makeStyles({
  container: {
    display: 'flex',
    justifyContent: 'center', // Center the footer content
    backgroundColor: dolphinTokens.colorDarkBlue,
    color: 'white',
    width: '100%', // Stretch the container fully
    height: 'auto', // Allow height to adjust based on content
    padding: '20px 0', // Add padding for better spacing
  },
  footer: {
    maxWidth: "1500px",
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: "center",
    width: '100%', // Ensure the footer takes full width within the container
    flexDirection: 'column', // Stack items vertically by default
    '@media (min-width: 600px)': { // Apply flex direction row for larger screens
      flexDirection: 'row',
    },
  },
  column: {
    flex: 1,
    padding: '20px 0', // Add padding for better spacing
    textAlign: 'center', // Center text for better mobile view
    '@media (min-width: 600px)': { // Apply padding for larger screens
      padding: '0 20px',
      textAlign: 'left', // Align text to left for larger screens
    },
  }
});

const Footer = () => {
  const styles = useStyles();

  return (
    <div className={styles.container}>
      <div className={styles.footer}>

        {/* Column 1 - logo & address */}
        <div className={styles.column}>
          <Logo />
          <Address />
        </div>

        {/* Column 2 - contact details & social media */}
        <div className={styles.column}>
          <ContactDetails />
          <SocialMedia />
        </div>

        {/* Column 3 - legal info */}
        <div className={styles.column}>
          <Legal />
        </div>

      </div>
    </div>
  );
};

export default Footer;